import {
  USER_CHANGED_MODAL_OPEN,
  USER_CHANGED_MODAL_CLOSE
} from 'src/store/constants';

export const userChangedModalOpen = payload => ({
  type: USER_CHANGED_MODAL_OPEN,
  payload
});

export const userChangedModalClose = () => ({
  type: USER_CHANGED_MODAL_CLOSE
});
